import { render, staticRenderFns } from "./MonitoringStatusTruk.vue?vue&type=template&id=55396fef&scoped=true&"
import script from "./MonitoringStatusTruk.vue?vue&type=script&lang=js&"
export * from "./MonitoringStatusTruk.vue?vue&type=script&lang=js&"
import style0 from "./MonitoringStatusTruk.vue?vue&type=style&index=0&id=55396fef&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55396fef",
  null
  
)

export default component.exports